import React, { useState } from "react";
import { useSelector } from "react-redux";

import FaxIcon from "../../../assets/fax.svg";
import EditIcon from "../../../assets/edit.svg";
import SendEmailBtn from "../../Modals/SendEmailBtn";
import { addClickRecord } from "../../../Utils/helper";
import { handleLinkClick } from "../../LawFirmDirectoryDashboard/main";
import FaxIconGrey from "../../../assets/fax-icon-greyscale.svg";
import costIcon from "../../../../public/BP_resources/images/icon/costs-icon-color.svg";
import { useDropdownTemplateAvailability } from "../../../Hooks/useGetTemplates";
import FaxWorkflowModal from "../../FaxWorkflow/FaxWorkflowModal";
import "../../common/CasePanelHeader.css";

import SendEmailBtnTreatment from "./SendEmailBtnTreatment";

const formatPhoneNumber = (number) => {
  if (!number) return null;
  const cleanedNumber = number.replace(/\D/g, "");

  const areaCode = cleanedNumber.slice(0, 3);
  const firstPart = cleanedNumber.slice(3, 6);
  const secondPart = cleanedNumber.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
const ContactPanelForTreatment = ({
  id,
  panel_name,
  name,
  address1,
  address2,
  city,
  state,
  zip_code,
  phone_number,
  ext = "",
  email,
  websiteURL,
  pageName = "",
  onSelectObject,
  buttonData,
  className = "",
  dynamic_label,
  genrate_doc_address,
  templateDropdownId,
  templatePageId,
  specialitie = {},
  meetingURL = "",
  isLink = false,
  fax_number = "",
  isSimple = false,
  showCost = false,
  costExists = false,
  showCoseRequestPopup = () => {},
  caseProviderId,
}) => {
  const [showFaxWorkflow, setShowFaxWorkflow] = useState(false);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const resolvedDropdownId = templateDropdownId;
  const resolvedPageId = templatePageId ?? page_id_click_record;
  const hasTemplateButton = buttonData?.some((button) =>
    /^(letter|generate document|Doc)$/i.test(button?.buttonText ?? "")
  );
  const { templatesAvailable } = useDropdownTemplateAvailability(
    resolvedPageId,
    resolvedDropdownId,
    { enabled: hasTemplateButton }
  );

  const isTemplateButtonDisabled = (button) =>
    button.disabled ||
    (/^(letter|generate document|Letter)$/i.test(button?.buttonText ?? "") && !templatesAvailable);
  const resolvedFaxContactId = id;
  const faxButtonDisabled = !fax_number;
  return (
    <>
      <div
        className={`info-div ${className} ${pageName === "litigation" ? "case-panel-edit-panel" : ""}`}
        style={{
          width: pageName !== "" && pageName?.startsWith("litigation") ? "auto" : "260px",
          minWidth: pageName !== "" && pageName?.startsWith("litigation") ? "min(255px, 100%)" : "",
        }}
      >
        <div
          className=""
          style={{
            cursor: "pointer",
          }}
        >
          <div onClick={onSelectObject}>
            {!isSimple && (
              <p
                className="bg-primary-5 columnsTitle text-center text-primary font-weight-semibold text-uppercase d-flex align-items-center justify-content-center position-relative"
                style={{
                  // backgroundColor: "var(--primary-15)",
                  height: "25px",
                  whiteSpace: "nowrap",
                }}
              >
                {panel_name}
                {pageName === "litigation" && (
                  <span className="case-panel-header-icon" aria-hidden="true">
                    <img src={EditIcon} width="15" height="15" alt="" />
                  </span>
                )}
              </p>
            )}
            {isLink ? (
              <>
                <div
                  style={{
                    height: "21px",
                    backgroundColor: "var(--primary-2)",
                  }}
                >
                  <p
                    className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                    style={{}}
                  >
                    {/*  */}
                  </p>
                </div>
                <div
                  style={{
                    height: "21px",
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  <p
                    className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                    style={{}}
                  >
                    {/*  */}
                  </p>
                </div>
                <div
                  style={{
                    height: "21px",
                    backgroundColor: "var(--primary-2)",
                  }}
                >
                  <p
                    className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                    style={{}}
                  >
                    {/*  */}
                  </p>
                </div>
                <div
                  style={{
                    height: "21px",
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  <p
                    className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                    style={{}}
                  >
                    {/*  */}
                  </p>
                </div>
                <div
                  className="d-flex justify-content-center"
                  style={{ backgroundColor: "var(--primary-2)" }}
                >
                  <a
                    href={meetingURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleLinkClick}
                    className="text-primary p-l-5 p-r-5 font-weight-semibold"
                    style={{
                      textDecoration: "underline",
                      height: "21px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Meeting Link
                  </a>
                </div>
              </>
            ) : (
              <>
                {name?.trim() ? (
                  <p
                    style={{ backgroundColor: "var(--primary-2)" }}
                    className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5 text-truncated"
                  >
                    {name}
                  </p>
                ) : (
                  <p
                    className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5"
                    style={{
                      backgroundColor: "var(--primary-2)",
                      color: "var(--primary-25)",
                    }}
                  >
                    {dynamic_label?.trim() ? dynamic_label : "Full Name"}
                  </p>
                )}
                <div>
                  <p
                    className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                    style={{
                      backgroundColor: "var(--primary-4)",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {address1 || address2 ? (
                      <p className="font-weight-semibold ">
                        {address1 && <span>{address1}</span>}
                        {address1 && address2 && <span>, </span>}{" "}
                        {/* Render comma only if both addresses exist */}
                        {address2 && <span>{address2}</span>}
                      </p>
                    ) : (
                      <span
                        className="font-weight-semibold text-capitalize"
                        style={{
                          backgroundColor: "var(--primary-4)",
                          color: "var(--primary-25)",
                        }}
                      >
                        Address
                      </span>
                    )}
                  </p>

                  <p
                    className="inline-row-h-21 text-capitalize bg-speciality-2 p-r-5 p-l-5"
                    style={{
                      backgroundColor: "var(--primary-2)",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {city ? (
                      <span className="font-weight-semibold">{city},</span>
                    ) : (
                      <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                        city,
                      </span>
                    )}{" "}
                    {state ? (
                      <span className="font-weight-semibold">{state}</span>
                    ) : (
                      <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                        state
                      </span>
                    )}{" "}
                    {zip_code ? (
                      <span className="font-weight-semibold">{zip_code}</span>
                    ) : (
                      <span
                        className="font-weight-semibold "
                        style={{
                          color: "var(--primary-25)",
                          textTransform: "uppercase",
                        }}
                      >
                        zip
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  <p
                    className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                    style={{
                      backgroundColor: "var(--primary-4)",
                    }}
                  >
                    {phone_number ? (
                      <span className="font-weight-semibold">
                        {formatPhoneNumber(phone_number)}
                      </span>
                    ) : (
                      <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                        (###) ###-####
                      </span>
                    )}
                    {ext && (
                      <>
                        <small
                          className="ms-1 font-weight-semibold"
                          style={{ color: "var(--primary-25)" }}
                        >
                          ext
                        </small>{" "}
                        <span className="font-weight-semibold">{ext}</span>
                      </>
                    )}
                  </p>
                </div>
              </>
            )}
          </div>

          {!isLink && (
            <div>
              <p
                className="inline-row-h-21 p-r-5 text-center p-l-5 bg-speciality-2"
                style={{ backgroundColor: "var(--primary-2)", height: "21px" }}
              >
                {websiteURL ? (
                  <a
                    href={websiteURL.startsWith("https") ? websiteURL : `https://${websiteURL}`}
                    target="_blank"
                    className="font-weight-semibold"
                    style={{
                      textDecoration: "none",
                      color: "#0000EE",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      verticalAlign: "middle",
                      maxWidth: "240px",
                    }}
                  >
                    {websiteURL}
                  </a>
                ) : (
                  <a className="" style={{ color: "var(--primary-25)", fontWeight: "600" }}>
                    www.websiteurl.com
                  </a>
                )}
              </p>
            </div>
          )}
        </div>
        <div className="mt-auto" style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
          {buttonData?.map((button, index) => (
            <button
              type="button"
              id={index}
              style={{
                width: showCost ? "72px" : "82px",
                minWidth: showCost ? "72px" : "82px",
                backgroundColor: "var(--primary-10)",
                borderColor: "var(--primary)",
                color: isTemplateButtonDisabled(button) ? "var(--primary-25)" : "var(--primary)",
                ...button.style,
              }}
              className={`btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${button.className}`}
              disabled={isTemplateButtonDisabled(button)}
              onClick={() => button.onClick(id, genrate_doc_address)}
            >
              {button.iconClassName && <i className={`${button.iconClassName} me-1`} />}
              {button.imgSrc && (
                <img className={button.imgClassName} src={button.imgSrc} alt="icon" />
              )}
              {button.buttonText}
            </button>
          ))}
          {pageName === "treatment" && (
            <SendEmailBtnTreatment
              email={email}
              specialitie={specialitie}
              name={name ?? ""}
              pageName={pageName ?? ""}
            />
          )}
          {pageName !== "treatment" && <SendEmailBtn email={email} />}
          <button
            style={{
              height: "25px",
              width: showCost ? "66px" : "81px",
              minWidth: showCost ? "66px" : "81px",

              backgroundColor: "var(--primary-10)",
              borderColor: "var(--primary)",
              color: faxButtonDisabled ? "var(--primary-25)" : "var(--primary)",
            }}
            className="btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center overflow-hidden info_email m-b-0 p-l-6 p-r-6"
            onClick={() => {
              addClickRecord(999, page_id_click_record);
              setShowFaxWorkflow(true);
            }}
            disabled={faxButtonDisabled}
          >
            {/* <i className="ic ic-19 ic-email-3d me-1" /> */}
            {faxButtonDisabled ? (
              <>
                <img src={FaxIconGrey} alt="Fax Icon" className="me-1 ic ic-15" />
              </>
            ) : (
              <>
                <img src={FaxIcon} alt="Fax Icon" className="me-1 ic ic-15" />
              </>
            )}
            Fax
          </button>
          {showCost && (
            <button
              style={{
                height: "25px",
                width: "32px",
                minWidth: "32px",

                backgroundColor: "var(--primary-10)",
                borderColor: "var(--primary)",
                color: "var(--primary)",
              }}
              className="btn btn-hover-contact-panel-row height-25 rounded-0 d-flex align-items-center justify-content-center overflow-hidden info_email m-b-0 p-l-6 p-r-6"
              onClick={() => {
                showCoseRequestPopup(true);
                addClickRecord(999, page_id_click_record);
              }}
              disabled={costExists}
            >
              <>
                <img
                  src={costIcon}
                  alt="Cost Icon"
                  className={`ic ic-15 ${costExists ? "grayscale" : ""}`}
                />
              </>
            </button>
          )}
        </div>
      </div>
      {showFaxWorkflow && (
        <FaxWorkflowModal
          show={showFaxWorkflow}
          onClose={() => setShowFaxWorkflow(false)}
          contactId={resolvedFaxContactId}
          caseProviderId={caseProviderId}
          recipientName={name}
          faxNumber={fax_number}
          recipientPhone={phone_number}
        />
      )}
    </>
  );
};

export default React.memo(ContactPanelForTreatment);
